import React from 'react';
import * as yup from 'yup';
import axios from 'axios';
import { Input } from 'antd';
import { createAdminHooks } from 'business/admin/services';
import { DataManagementConfig } from 'business/admin/types';
import {
  EvaluationRequestStatus,
  EvaluationRequestStatusFormValues,
} from 'business/evaluationRequestStatus/types';
import { evaluationRequestStatusKeys } from 'business/evaluationRequestStatus/hooks/queries';
import InputField from 'technical/form/formik/InputField';
import { getAPITablePosition } from 'technical/utils/getApiTablePosition';

const { TextArea } = Input;

const config: DataManagementConfig<
  EvaluationRequestStatus,
  Pick<EvaluationRequestStatus, 'name' | 'description'>
> = {
  entity: 'evaluation-request-status',
  hooks: createAdminHooks({
    keys: evaluationRequestStatusKeys,
    async fetch(page) {
      return (
        await axios.get('/v1/evaluation-request-status', {
          params: page ? getAPITablePosition(page) : {},
        })
      ).data;
    },
    async create(entity) {
      return axios.post(`/v1/evaluation-request-status`, {
        name: entity.name,
        description: entity.description,
      });
    },
    async update(entity) {
      return axios.patch(`/v1/evaluation-request-status/${entity.id}`, {
        name: entity.name,
        description: entity.description,
      });
    },
    async del(id) {
      return axios.delete(`/v1/evaluation-request-status/${id}`);
    },
  }),
  columns(permissions) {
    return [
      {
        dataIndex: 'name',
        key: 'name',
        render: (_value, entity) => {
          return (
            <InputField<EvaluationRequestStatusFormValues>
              valueKey="name"
              readOnly={!permissions.update(entity)}
              showCount
              maxLength={50}
            />
          );
        },
      },
      {
        dataIndex: 'description',
        key: 'description',
        render: (_value, entity) => {
          return (
            <InputField<EvaluationRequestStatusFormValues>
              valueKey="description"
              readOnly={!permissions.update(entity)}
              component={TextArea}
              autoSize={{ minRows: 1, maxRows: 5 }}
              showCount
              maxLength={500}
            />
          );
        },
      },
    ];
  },
  schema: yup.object({
    name: yup.string().trim().min(1).max(50).required(),
    description: yup.string().trim().min(1).max(500).required(),
  }),
  defaultValues: {
    name: '',
    description: '',
  },
  permissions: {
    add: () => false,
    delete: () => false,
  },
};

export default config;
